<footer class="e11-bg-skin-app-bg-dark">
  <h3 class="e11-text-white">footer</h3>
</footer>
